<template>
  <div class="seed-account-poll-container">
    <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
      <!-- <star-condition-cell label="账号类型">
        <a-select v-model="searchCondition.type" style="width: 100%" allowClear>
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.type"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell> -->
      <star-condition-cell label="账号id">
        <a-input v-model="searchCondition.account" style="width: 100%" allowClear></a-input>
      </star-condition-cell>
      <star-condition-cell label="推荐等级">
        <a-select v-model="searchCondition.scoreLevel" style="width: 100%" allowClear>
          <a-select-option :value="99"> 无 </a-select-option>
          <a-select-option :value="0"> A </a-select-option>
          <a-select-option :value="1"> B </a-select-option>
          <a-select-option :value="2"> C </a-select-option>
          <a-select-option :value="3"> D </a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="审核状态">
        <a-select v-model="searchCondition.verifyStatus" style="width: 100%" allowClear>
          <a-select-option :value="-2"> 不需审核 </a-select-option>
          <a-select-option :value="-1"> 拒绝通过 </a-select-option>
          <a-select-option :value="0"> 等待审核 </a-select-option>
          <a-select-option :value="1"> 通过 </a-select-option>
        </a-select>
      </star-condition-cell>

      <!-- <star-condition-cell label="用户昵称">
        <a-input v-model="searchCondition.accountName" style="width: 100%" allowClear></a-input>
      </star-condition-cell> -->
    </star-condition-layout>

    <div class="table-container">
      <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary" slot="right" @click="showCreate">新建</a-button>
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="false"
        @change="handleTableChange"
        rowKey="seedPoolId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="scoreLevel" slot-scope="label">
          {{ toScrollName(label) }}
        </span>

        <span slot="type" slot-scope="label">
          {{ toClassName(label) }}
        </span>

        <span slot="verifyStatus" slot-scope="label">
          {{ toVerifyStatusName(label) }}
        </span>

        <span slot="verifyUserId" slot-scope="label">
          {{ label === 0 ? '系统' : '人工' }}
        </span>

        <span slot="action" slot-scope="_, record">
          <template v-if="record.verifyStatus === 0">
            <a-popconfirm
              title="是否审核通过？"
              @confirm="() => doExanmine(record, true)"
              @cancel="() => doExanmine(record, false)"
              cancelText="不通过"
              okText="通过"
            >
              <a-button type="link">审核 </a-button>
            </a-popconfirm>

            <a-divider type="vertical"></a-divider>
          </template>
          <a-popconfirm
            v-if="record.status !== -1"
            title="禁用将无法使用该账号执行任务，是否确认禁用？"
            @confirm="() => onChangeStatus(record, -1)"
          >
            <a-button type="link">禁用 </a-button>
          </a-popconfirm>
          <a-popconfirm
            v-else
            title="当前账号为异常账号，是否确认解除禁用？"
            @confirm="() => onChangeStatus(record, 1)"
          >
            <a-button type="link">解除禁用 </a-button>
          </a-popconfirm>

          <!-- <a-divider type="vertical"></a-divider> -->
          <!-- <a-button type="link" @click="showModify(record)">编辑</a-button> -->
          <a-divider type="vertical"></a-divider>
          <a-popconfirm
            title="确定要删除吗，删除后将无法使用?"
            @confirm="() => handleDelete(record)"
          >
            <a-button type="link">删除 </a-button>
          </a-popconfirm>
        </span>
        <template slot="footer">
          <div style="float: right; margin-bottom: 20px">
            <a-button @click="upPage" style="margin-right: 12px">上一页</a-button>
            <a-button @click="downPage">下一页</a-button>
          </div>
        </template>
      </a-table>
    </div>

    <CreateAndModify
      :visible="isShowCreateAndModify"
      :isModify="isModalModifMod"
      :confirmLoading="createAndModifyLoading"
      :handleOk="isModalModifMod ? onModify : onCreate"
      @closeModel="closeModel"
      :createAndModifyData.sync="createAndModifyData"
      :spiderClassOptions="spiderClassOptions"
      :data="createAndModifyData"
    />
  </div>
</template>

<script>
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { onHttpResponseSilent, onHttpResponse } from '@/utils/request'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'
import {
  getSeedAccountPoolApi,
  deleteSeedAccountPollApi,
  createSeedAccountPoolApi,
  modifySeedAccountPoolApi,
  modifySeedAccountPoolStatusApi,
  verifySeedAccountPoolApi
} from '@/api/Dispatch/Account/index'

import CreateAndModify from './CreateAndModify'
import { message } from 'ant-design-vue'

export default {
  mixins: [tableSettingToStoreMixin()],
  components: { CreateAndModify },
  data() {
    return {
      loading: false,
      searchCondition: {
        type: '',
        scoreLevel: '',
        accountName: '',
        account: '',
        verifyStatus: ''
      },
      spiderClassOptions: [],

      tableDensity: 'middle',
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      tableData: [],
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        // {
        //   title: '种子池id',
        //   dataIndex: 'seedPoolId',
        //   show: true,
        //   width: 90,
        //   align: 'center'
        // },
        {
          title: '账号名',
          dataIndex: 'accountName',
          show: true,
          align: 'center'
        },
        {
          title: '账号id',
          dataIndex: 'account',
          show: true,
          align: 'center'
        },
        {
          title: '推荐等级',
          dataIndex: 'scoreLevel',
          show: true,
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'scoreLevel' }
        },
        {
          title: '活跃等级',
          dataIndex: 'activeScoreLevel',
          show: false,
          scopedSlots: { customRender: 'scoreLevel' },
          width: 150,
          align: 'center'
        },
        {
          title: '打分时间',
          dataIndex: 'scoreTime',
          show: false,
          width: 150,
          align: 'center'
        },
        {
          title: '类别',
          dataIndex: 'type',
          show: true,
          align: 'center',
          width: 70,
          scopedSlots: { customRender: 'type' }
        },
        {
          title: '审核人',
          dataIndex: 'verifyUserId',
          show: false,
          align: 'center',
          scopedSlots: { customRender: 'verifyUserId' }
        },
        {
          title: '审核状态',
          dataIndex: 'verifyStatus',
          show: true,
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'verifyStatus' }
        },
        {
          title: '最近调度时间',
          dataIndex: 'scoreTime',
          show: true,
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 180,
          align: 'center'
        }
      ],

      isShowCreateAndModify: false,
      isModalModifMod: false,
      createAndModifyLoading: false,
      createAndModifyData: {
        type: '',
        accountName: '',
        account: '',
        password: ''
      }
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  mounted() {
    this.querySpiderClassInfo()
    this.handleSearch()
  },

  methods: {
    upPage() {
      if (this.pagination.current === 1) {
        message.info('已经到第一页了')
      } else {
        this.pagination.current -= 1
        this.getTableData()
      }
    },
    downPage() {
      this.pagination.current += 1
      this.getTableData()
    },
    handleSearch() {
      this.pagination.current = 1
      this.getTableData()
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getTableData()
    },

    getTableData() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchCondition
      }
      this.loading = true
      getSeedAccountPoolApi(query)
        .then(onHttpResponseSilent)
        .then(({ data, extra }) => {
          this.tableData = data
          // this.pagination.total = extra.page.pageCount || 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    reset() {
      this.searchCondition = {
        type: '',
        scoreLevel: '',
        accountName: '',
        account: '',
        verifyStatus: ''
      }
      this.handleSearch()
    },

    querySpiderClassInfo() {
      let doneTypes = ['twitter', 'weibo']
      querySpiderClassInfoApi()
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.spiderClassOptions = data.filter((d) => doneTypes.includes(d.type))
        })
    },

    toClassName(type) {
      let tar = this.spiderClassOptions.filter((s) => s.type === type)[0]
      if (tar) {
        return tar.spiderClassName
      }
      return ''
    },

    toScrollName(num) {
      switch (num) {
        case 0:
          return 'A'
        case 1:
          return 'B'
        case 2:
          return 'C'
        case 3:
          return 'D'
        case 99:
          return '无'
        default:
          return '---'
      }
    },

    toVerifyStatusName(label) {
      switch (label) {
        case -2:
          return '不需审核'
        case -1:
          return '拒绝通过'
        case 0:
          return '等待审核'
        case 1:
          return '通过'
      }
    },

    handleDelete(record) {
      deleteSeedAccountPollApi(record.seedPoolId).then(onHttpResponse).then(this.getTableData)
    },

    showCreate() {
      this.createAndModifyData = {
        type: '',
        accountName: '',
        account: '',
        password: ''
      }
      this.isModalModifMod = false
      this.isShowCreateAndModify = true
    },

    closeModel() {
      this.isShowCreateAndModify = false
    },

    showModify(record) {
      this.createAndModifyData = { ...record }
      this.isModalModifMod = true
      this.isShowCreateAndModify = true
    },

    onCreate(createData) {
      this.createAndModifyLoading = true
      createSeedAccountPoolApi(createData)
        .then(onHttpResponse)
        .then(this.getTableData)
        .then(() => {
          this.isShowCreateAndModify = false
        })
        .catch(() => {})
        .finally(() => {
          this.createAndModifyLoading = false
        })
    },

    onModify(modifyData) {
      this.createAndModifyLoading = true
      modifySeedAccountPoolApi(modifyData)
        .then(onHttpResponse)
        .then(this.getTableData)
        .then(() => {
          this.isShowCreateAndModify = false
        })
        .catch(() => {})
        .finally(() => {
          this.createAndModifyLoading = false
        })
    },

    onChangeStatus(record, status) {
      modifySeedAccountPoolStatusApi({ seedPoolId: record.seedPoolId, status })
        .then(onHttpResponse)
        .then(this.getTableData)
    },

    doExanmine(record, isPass) {
      verifySeedAccountPoolApi({ seedPoolId: record.seedPoolId, isPass })
        .then(onHttpResponse)
        .then(this.getTableData)
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.seed-account-poll-container {
  width: 100%;
  padding: 16px;

  .table-container {
    background-color: white;
    padding: 0 16px;
    margin-top: 16px;
  }
}
</style>
